module.exports = __webpack_public_path__ + "001be112b5fb182ca5ab2a0dcd0f284a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/UG.svg
// module id = Iw5E
// module chunks = 0